<template>
	<div>
        <slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
        data () {
			return {
				element: undefined
			}
		},
		mounted() {
        },
        methods: {
            toggleHeader() {
            this.element = this.$refs.nav_mobile;
                if (this.element != null && this.element.style.display == "block") {
                    this.element.style.display = "none";
                } else {
                    if (this.element != null) {
                        this.element.style.display = "block";
                    }
                }
            }
        }
	}
</script>
